import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import { insertMarketPrice } from "../../../http/api/MarketPriceAPI";
import { CompanyTitledPage } from "../../TitledPage";
import MarketPriceSettingForm from "../components/MarketPriceSettingForm";
import { SYSTEM_PATH_COMPANY } from "../../../App";
import { useMarketPriceSettingForm } from "../hooks/useMarketPriceSettingForm";
import { useMarketPriceSettingValidation } from "../hooks/useMarketPriceSettingValidation";


// 新規荷主登録ページ
const MarketPriceSettingRegisterPage = () => {
  const navigate = useNavigate();

  const form = useMarketPriceSettingForm();

  const {errors, hasErrors} = useMarketPriceSettingValidation(form);

  // 登録ボタンをクリックするイベント
  async function handleClickRegister() {
    try {
      const marketPriceId = await form.register();
      
      alert("登録完了しました。")
      navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", { state: { marketPriceId } })

    } catch (error) {    
      alert("登録失敗しました。")
    }
   
  }

  const handleClickReturn = (event) => {
    navigate(-1);
  };

  return (
    <CompanyTitledPage title="市況価格表登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              市況価格表情報
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickRegister}
              id="market-price-form-submit-button"
              disabled={hasErrors()}
            >
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 市況登録情報 */}
      <MarketPriceSettingForm form={form} errors={errors} />
     
    </CompanyTitledPage>

  );
};

export default MarketPriceSettingRegisterPage;
